export enum SignLoanAgreementSteps {
  GeneralStep = 'GeneralStep',
  OneSpanSignWidgetStep = 'OneSpanSignWidgetStep',
  SendApplicationForFundingStep = 'SendApplicationForFundingStep',
}
